"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Radio = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _config = require("./config");
var _styledRadio = require("./styled-radio");
var _excluded = ["analyticsId", "className", "clickCallback", "dataTestId", "disabled", "fullWidth", "marginBottom", "marginRight", "radioLabel", "radioName", "srLabel", "style"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var forwardRef = _react["default"].forwardRef,
  useCallback = _react["default"].useCallback,
  useEffect = _react["default"].useEffect,
  useMemo = _react["default"].useMemo,
  useRef = _react["default"].useRef;
var propTypes = {
  analyticsId: _propTypes["default"].string,
  className: _propTypes["default"].string,
  clickCallback: _propTypes["default"].func,
  dataTestId: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  fullWidth: _propTypes["default"].bool,
  marginBottom: _propTypes["default"].bool,
  marginRight: _propTypes["default"].bool,
  radioName: _propTypes["default"].string,
  radioLabel: _propTypes["default"].string,
  srLabel: _propTypes["default"].string,
  style: _propTypes["default"].object
};
var defaultProps = {
  analyticsId: undefined,
  className: '',
  clickCallback: undefined,
  dataTestId: '',
  disabled: false,
  fullWidth: false,
  marginBottom: false,
  marginRight: false,
  radioName: '',
  radioLabel: '',
  srLabel: '',
  style: undefined
};
var Radio = exports.Radio = forwardRef(function (_ref, ref) {
  var analyticsId = _ref.analyticsId,
    className = _ref.className,
    clickCallback = _ref.clickCallback,
    dataTestId = _ref.dataTestId,
    disabled = _ref.disabled,
    fullWidth = _ref.fullWidth,
    marginBottom = _ref.marginBottom,
    marginRight = _ref.marginRight,
    radioLabel = _ref.radioLabel,
    radioName = _ref.radioName,
    srLabel = _ref.srLabel,
    style = _ref.style,
    others = _objectWithoutProperties(_ref, _excluded);
  // Component config
  var label = _config.componentConfig.label,
    srLabelConfig = _config.componentConfig.srLabel;
  // Unique IDs
  var inputId = useMemo(function () {
    return (0, _fuseUtils.namedUuid)('fuse-radio-input');
  }, []);
  // Refs
  var inputRef = useRef();
  // Event handler
  var radioClickHandler = useCallback(function (e) {
    // Run callback
    if (typeof clickCallback === 'function') clickCallback(e);
  }, []);
  useEffect(function () {
    var uA = navigator.userAgent;
    var isSafariDesktop = /Safari/i.test(uA) && !/Chrome/i.test(uA) && !/Mobi|Android/i.test(uA);

    // Fix for Safari desktop radio focus outline to show only on keyboard focus
    if (isSafariDesktop) inputRef.current.classList.add('fuse-radio__input--safari-focus');
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_styledRadio.StyledRadio, {
    className: className,
    "data-analyticsid": analyticsId,
    "data-testid": dataTestId || 'fuse-radio-test-id',
    fullWidth: fullWidth,
    marginBottom: marginBottom,
    marginRight: marginRight,
    ref: ref,
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_styledRadio.StyledRadioInput, _extends({
    disabled: disabled,
    id: inputId,
    name: radioName,
    onClick: function onClick(e) {
      return radioClickHandler(e);
    },
    ref: inputRef,
    type: "radio"
  }, others)), /*#__PURE__*/_react["default"].createElement(_styledRadio.StyledRadioLabel, {
    color: label.color,
    disabled: disabled,
    htmlFor: inputId,
    size: label.size,
    tag: label.tag,
    type: label.type
  }, radioLabel, srLabel && /*#__PURE__*/_react["default"].createElement(_fuseUtils.StyledScreenReaderSpan, {
    className: srLabelConfig.className
  }, ' ', srLabel)));
});
Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;
var _default = exports["default"] = Radio;